<!-- Common Templates -->

<div
  class="px-6 lg:px-16"
  id="magazine-detail-container"
  [ngClass]="{ 'se-magazine': isSelectionAndEssence() }"
>
  <!-- Breadcrumbs Section -->
  @if (magazine(); as magazine) {
    <div class="mt-16">
      <dhp-breadcrumbs [crumbs]="breadcrumbItems()"></dhp-breadcrumbs>
    </div>
  } @else {
    <div class="px-6 lg:px-16">
      {{ loading() ? ('components.header.loading' | translate) : error() }}
    </div>
  }

  <!-- Magazine Information Section -->
  @if (magazine(); as magazine) {
    <dhp-details-header
      [magazine]="magazine"
      [edition]="magazine.latest_edition"
      [subtitle]="magazine.subtitle"
      [imageAlt]="'components.magazineAndJournalsDetail.imagePlaceholder'"
    >
      <ng-container buttons>
        <dhp-subscribe-button
          [magazineId]="magazine.id"
          [userAccessLevel]="magazine.user_access"
        ></dhp-subscribe-button>
        @if (hasEditions() && !isSelectionAndEssence()) {
          <button
            class="btn-secondary btn flex w-full gap-1 md:w-auto md:gap-2"
            [routerLink]="[
              '/magazines/detail',
              magazine.id,
              magazine.slug,
              'edition',
              latestEdition()?.id,
            ]"
          >
            <span>{{ 'components.journalItem.lastEdition' | translate }}</span>
            <img
              class="h-6 w-6"
              [alt]="
                'components.magazineAndJournalsDetail.lastEditionIcon'
                  | translate
              "
              src="/assets/icons/last_edition.svg"
            />
          </button>
        }
        @if (magazine.media?.trial_issue; as trialIssue) {
          <a
            class="btn-secondary btn flex w-full gap-1 md:w-auto md:gap-2"
            [href]="trialIssue.url"
            target="_blank"
            download
          >
            <span>{{ 'components.journalItem.viewCopy' | translate }}</span>
            <img
              class="h-6 w-6"
              [alt]="
                'components.magazineAndJournalsDetail.downloadIcon' | translate
              "
              src="/assets/icons/download.svg"
            />
          </a>
        }
      </ng-container>
      <ng-container metadata>
        <div class="flex flex-col gap-10 text-base">
          <div class="flex flex-col gap-4">
            @if (magazine.frequency) {
              <div class="grid grid-cols-1 gap-2 md:grid-cols-12">
                <strong class="md:col-span-3">
                  {{
                    (magazine.selectionAndEssence ?? false)
                      ? ('components.magazineAndJournalsDetail.publicationFrequency'
                        | translate)
                      : ('components.magazineAndJournalsDetail.frequency'
                        | translate)
                  }}
                </strong>
                <div
                  class="break-words md:col-span-9"
                  [innerHTML]="magazine.frequency"
                ></div>
              </div>
            }
            @if (magazine.issn_digital; as issnDigital) {
              <div class="grid grid-cols-1 gap-2 md:grid-cols-12">
                <strong class="md:col-span-3">
                  {{
                    'components.magazineAndJournalsDetail.issnDigital'
                      | translate
                  }}
                </strong>
                <div class="break-words md:col-span-9">{{ issnDigital }}</div>
              </div>
            }
          </div>
        </div>
      </ng-container>
    </dhp-details-header>
  }

  <!-- Magazine Tabs Section (replacing the Accordion and Editions sections) -->
  @if (magazine(); as magazine) {
    <dhp-advertisement
      class="-mx-6 lg:-mx-16"
      [referenceId]="magazine.id"
      placement="magazine"
    />
    <div class="mt-10 border-gray-200 pt-8 lg:pt-14">
      <dhp-magazine-tabs
        [id]="magazine.id"
        [magazine]="magazine"
        [years]="years()"
        [yearSelected]="yearSelected"
        [editions]="(editions$ | async) ?? []"
        [loading]="loading()"
        [isEditionOverview]="false"
        [isSelectionAndEssence]="magazine.selectionAndEssence ?? false"
        (yearSelectedChange)="yearSelected = $event"
      ></dhp-magazine-tabs>
    </div>
  }
</div>

<!-- Notifications Section -->
<!-- Disabled for now. The titlekey and descriptions for this element should be re-evaluated when enabled. Make relative to journal/magazine title. -->
<!-- <dhp-get-notifications-section *ngIf="magazine()" titleKey="components.editionOverview.stayUpdated"></dhp-get-notifications-section> -->

<!-- No Editions Available Message -->
<ng-template #noEditions>
  @if (!loading()) {
    <div class="text-center text-gray-500">
      {{ 'components.journalItem.noEditionsAvailable' | translate }}
    </div>
  }
</ng-template>

<!-- Year Filter Dialog Component -->
<dhp-year-filter-dialog
  [(isOpen)]="isYearFilterOpen"
  [(yearSelected)]="yearSelected"
  [years]="years()"
></dhp-year-filter-dialog>
